export class Report {
  id: number;
  hash: string;
  name: string;
  footer: any;
  rows: Array<any> = [];
  summary: any;
  fileToken: string;
  columns?: Array<any>;
  subColumns?: Array<any>;
  options?: any;
  reportName?: string;
  legend?: any;
  fileName?: string;
  tmp?: any;
}
